export const isDev = process.env.ENV_TYPE === 'dev';
